import { Plugin } from "prosemirror-state";
import { hasAttr, hasType } from "../../../core/helpers";
import { randomId } from "../../../helpers/random";
export function HeadingIdPlugin() {
    return new Plugin({
        appendTransaction: (transactions, oldState, newState) => {
            const headingIds = new Set();
            const tr = newState.tr;
            let modified = false;
            if (transactions.some((transaction) => transaction.docChanged)) {
                newState.doc.descendants((node, pos) => {
                    const { heading } = newState.schema.nodes;
                    const hasIdAttr = hasAttr(node, "id");
                    const shouldGenerateNewId = headingIds.has(node.attrs.id) || !hasIdAttr;
                    if (hasIdAttr)
                        headingIds.add(node.attrs.id);
                    if (hasType(node, heading) && shouldGenerateNewId) {
                        const newId = randomId();
                        headingIds.add(newId);
                        tr.setNodeMarkup(pos, null, {
                            ...node.attrs,
                            id: newId,
                        });
                        modified = true;
                    }
                });
            }
            return modified ? tr : null;
        },
    });
}
